import React, {lazy, Suspense} from 'react';

import {
  Box,
  Button,
  IconButton,
  Grid,
  Menu,
  MenuItem,
  Paper,
  Chip,
  Container,
  Typography,
  Stack
} from '@mui/material';

import {
  blue,
  lightBlue,
  grey,
  blueGrey,
  teal
} from '@mui/material/colors';

import moment from 'moment';
import 'moment/locale/ko';

const HeroSection          = lazy(() => import("./HeroSection"));
const InformationSection   = lazy(() => import("./InformationSection"));
const DesignSection        = lazy(() => import("./DesignSection"));
const CertificationsSection        = lazy(() => import("./CertificationsSection"));
const ClientSection        = lazy(() => import("./ClientSection"));
const ProductTypeSection        = lazy(() => import("./ProductTypeSection"));
const MissionSection = lazy(() => import("./MissionSection"));
const CTASection = lazy(() => import("./CTASection"));
const CustomerSection = lazy(() => import("./CustomerSection"));

const selling_link = "https://ppi.g2b.go.kr:8914/sm/dm/sch/searchGoodsDetail.do?invGdsIdntNo=00027354";

function CleaningCartPage(props){
  return (
    <>
      <Suspense fallback={null}>
        <HeroSection 
          selling_link={selling_link}/>
        <InformationSection 
          selling_link={selling_link}/>
        <DesignSection 
          selling_link={selling_link}/>
        <CertificationsSection 
          selling_link={selling_link}/>
        <ClientSection 
          selling_link={selling_link}/>
        <ProductTypeSection 
          selling_link={selling_link}/>
        <MissionSection 
          selling_link={selling_link}/>
        <CTASection 
          selling_link={selling_link}/>
        <CustomerSection 
          selling_link={selling_link}/>
      </Suspense>
    </>
  );
}

export default CleaningCartPage;
